export default __webpack_public_path__ + "static/media/stakelogic-mono.1aaceed5.svg";